document.addEventListener('DOMContentLoaded', function () {
  const headers = document.querySelectorAll('#ProductAccordion .accordion-header');
  
  headers.forEach((header) => {
    header.addEventListener('click', function () {
      const isActive = header.classList.contains('active');
      
      // Önce tümünü kapat
      headers.forEach((h) => {
        h.classList.remove('active');
        h.setAttribute('aria-expanded', 'false');
        h.nextElementSibling.style.display = 'none';
      });
      
      // Eğer tıklanan zaten aktif değilse onu aç
      if (!isActive) {
        header.classList.add('active');
        header.setAttribute('aria-expanded', 'true');
        header.nextElementSibling.style.display = 'block';
      }
    });
  });
});